import styled from 'styled-components'

import { device } from '~/styles/utils'

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 24px 0 32px;

  &:first-child {
    padding: 32px 0;
  }

  @media ${device('notMobile')} {
    && {
      padding: 0 0 48px;
      display: block;
    }
  }
`
